<template>
  <div>
    <WelcomeMessage />
    <NavMenu></NavMenu>
    <router-view></router-view>
  </div>
</template>

<script>
import { RouterView } from "vue-router";
import NavMenu from "../../layout/Planning/NavMenu.vue";
import WelcomeMessage from "../../components/WelcomeMessage.vue";
import { useFutureStore } from "@/store/future/store.js";

export default {
  components: { NavMenu, WelcomeMessage },
  data() {
    return {
      plan: "",
    };
  },
  created() {
    const store = useFutureStore();
    store.get_planning_setting();
    store.get_objective();
    if (this.last_planning_setting) {
      this.planning_setting = {
        ...this.last_planning_setting,
        inflation_rate: parseFloat(this.last_planning_setting.inflation_rate),
        interest_rate: parseFloat(this.last_planning_setting.interest_rate),
      };
    }
  },
  computed: {
    planning_setting_data() {
      const store = useFutureStore();
      const data = store.planning_setting;

      return data;
    },
    last_planning_setting() {
      const store = useFutureStore();
      const data = store.last_planning_setting;

      return data;
    },
  },
  components: { NavMenu, WelcomeMessage },
  methods: {
  },
};
</script>
<style scoped>
</style>
